import React from "react";
import { Box, Button, Icon, Text } from "@chakra-ui/react";

const Varient2 = ({ title, text, link, btnText }: any) => {
  return (
    <Box bg="#F2F6FF" position="relative">
      <Icon
        width="301"
        height="221"
        viewBox="0 0 301 221"
        position="absolute"
        top="0"
        right="0"
      >
        <path
          d="M103.423 104.3C-34.0614 132.26 -5.41883 26.4166 26.0879 -30H316V199.766L298.067 205.591C51.8662 278.08 275.278 69.3492 103.423 104.3Z"
          fill="#5D8DE9"
        />
      </Icon>
      <Box
        textAlign="center"
        color="#3B3435"
        px="20px"
        py={{ base: "31px", md: "49px" }}
      >
        <Text
          textStyle={{ base: "h3", md: "h2" }}
          mb={{ base: "12px", md: "24px" }}
        >
          {title}
        </Text>
        <Text
          textStyle="body1-md"
          mb="24px"
          maxW="1097px"
          mx="auto"
          color={{ base: "#03081A", md: "#544D4F" }}
        >
          {text}
        </Text>
        <Button
          as="a"
          href={link}
          colorScheme="blue"
          bg="#4358F6"
          textStyle="btn-lg"
          size="lg"
        >
          {btnText}
        </Button>
      </Box>
    </Box>
  );
};

export default Varient2;
